<kendo-tilelayout>
  <kendo-tilelayout-item [col]="1" [colSpan]="3">
    <kendo-tilelayout-item-header>
      <div class="k-d-flex k-justify-content-between k-align-items-center">
        <div>
          <h4 class="k-m-0">Provider's Schedule</h4>
        </div>
        <div>
          <button kendoButton themeColor="primary" fillMode="solid" [svgIcon]="clockIcon"
            (click)="displayScheduleTimeDialog('schedule time')">
            Schedule Time
          </button>
        </div>
      </div>
    </kendo-tilelayout-item-header>
    <kendo-tilelayout-item-body class="!k-p-0">
      <div class="app-student-scheduler">
        <kendo-scheduler [kendoSchedulerBinding]="schedulerEditService.events | async" [selectedDate]="selectedDate"
          [eventClass]="getEventColor" style="height: 600px;" (dateChange)="onDateChange($event)"
          [loading]="schedulerEditService.loading" [weekStart]="1">
          <ng-template kendoSchedulerEventTemplate let-event="event" [modelFields]="schedulerEditService.fields"
            [selectable]="false">
            <div *ngIf="event?.dataItem?.isHoliday; else regularEventContent" class="holiday-event-content" [ngClass]="getEventColor(event)">
              <span class="!k-font-semibold">{{ event?.dataItem?.title }}</span>
            </div>
            <ng-template #regularEventContent>
              <div  #target kendoPopoverAnchor [popover]="viewScheduleEvent" #popoverAnchor="kendoPopoverAnchor" (click)="onViewScheduleEvent(event, popoverAnchor)">
                @if(event?.dataItem?.sessionType === 1 && event?.dataItem?.scheduleType === 'Provider'){
                <div>
                  <strong class="k-font-semibold">[{{ event?.dataItem?.language }}]
                    {{event?.dataItem?.serviceType}} -
                    {{event?.dataItem?.studentMandates?.length}}/{{getGroupSize(event?.dataItem?.groupSize)}}</strong>
                  <p class="!k-m-0"><small>{{ event?.dataItem?.location }}</small></p>
                </div>
                }
                @if(event?.dataItem?.sessionTypes !== 1 && event?.dataItem?.scheduleType === 'Provider'){
                <div>
                  <strong class="k-font-semibold">{{getSesstionTypeName(event?.dataItem?.sessionTypes)}}</strong>
                  @if(getLocationBySessionType(event?.dataItem?.sessionTypes)){
                  <p class="!k-m-0"><small>{{
                      event?.dataItem?.location }}</small></p>
                  }
                </div>
                }
                @if(event?.dataItem?.scheduleType === 'Evaluator'){
                  <div>
                    <strong class="k-font-semibold">[EN] {{event?.title}}</strong>
                    <p class="!k-m-0"><small>[{{event?.dataItem?.location}}] - {{
                      event?.dataItem?.studentName }}</small></p>
                </div>
              }  
              </div>
            </ng-template>
            <!-- <div [ngClass]="getEventColor(event)">
         <strong>[{{event?.dataItem?.language}}]</strong><span> {{event?.title}}</span>
         <p class="!k-m-0">{{event?.dataItem?.location}}-{{event?.description}}</p>
        </div> -->

          </ng-template>
          <kendo-scheduler-week-view [eventHeight]="28"></kendo-scheduler-week-view>

        </kendo-scheduler>
      </div>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
</kendo-tilelayout>

<!-------Provider View Schedule Event---------->
<kendo-popover #viewScheduleEvent [width]="420" position="right" [templateData]="getViewScheduleEventData"
  style="border-radius: 14px;">
  <ng-template kendoPopoverTitleTemplate let-data="data">
    <div >
      <div class="k-d-flex k-justify-content-between k-align-items-center">
        <div class="k-d-flex k-align-items-center k-gap-sm" *ngIf="data.sessionType === 1">
          <kendo-svg-icon [icon]="calendar" size="xlarge" themeColor="primary"></kendo-svg-icon>
          <h4 class="!k-m-0 !k-p-0">[{{data.language}}] {{data.serviceType}} -
            {{data?.selectedStudentMandates?.length}}/{{getGroupSize(data?.groupSize)}}</h4>
        </div>
        <div class="k-d-flex k-align-items-center k-gap-sm" *ngIf="data.sessionType !== 1">
          <kendo-svg-icon [icon]="calendar" size="xlarge" themeColor="primary"></kendo-svg-icon>
          <h4 class="!k-m-0 !k-p-0">{{data.sessionTypeName}}</h4>
        </div>
        <div>
          <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small" (click)="onCloseViewScheduleEvent()"
            title="Close"></button>
        </div>
      </div>
    </div>

  </ng-template>

  <ng-template kendoPopoverBodyTemplate let-data="data">
    <div class="view-schedule-popover-body">
      <div class="k-d-flex k-align-items-center k-gap-lg">
        <kendo-svg-icon [icon]="clockIcon" size="medium"></kendo-svg-icon>
        <p>{{data?.meetingDate}}, {{data?.startTime | date:'h:mm a'}} - {{data?.endTime | date:'h:mm a'}}</p>
      </div>
      <div *ngIf="data.sessionType === 1">
        <div class="k-d-flex k-align-items-center k-gap-lg">
          <kendo-svg-icon [icon]="users" size="medium"></kendo-svg-icon>
          <p class="font-12 secondary-color k-my-0">Students/Mandates</p>
        </div>
        <div class="k-ml-8">
          <p class="k-mt-0">{{data?.studentMandates}}</p>
        </div>
      </div>
     
      <div *ngIf="data.sessionType === 1">
        <div class="k-d-flex k-align-items-center k-gap-lg">
          <kendo-svg-icon [icon]="locationDot" size="medium"></kendo-svg-icon>
          <strong>{{data?.locationType}}</strong>
        </div>
        <div class="k-ml-8">
          <p class="k-my-0 location-text">
            {{ data?.location }}
          </p>
        </div>
      </div>
      <div class="k-d-flex k-align-items-center k-gap-lg" *ngIf="data.sessionType === 1">
        <kendo-svg-icon [icon]="stairs" size="medium"></kendo-svg-icon>
        <p class="location-text">{{data?.floorRoom}}</p>
      </div>

      <div class="k-d-flex k-align-items-center k-gap-lg k-ml-8 k-mt-4 k-mb-4"
        *ngIf="data.sessionType === 1" >
        <kendo-label [for]="switch" text="Teams Meeting / Tele"></kendo-label>
        <kendo-switch #switch [readonly]="readonly" [(ngModel)]="data.teamsMeeting"></kendo-switch>
      </div>
    </div>
  </ng-template>
 
</kendo-popover>